import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_BANNER,
  AddBannerAction,
  DELETE_BANNER,
  DeleteBannerAction,
  GET_BANNER,
  GET_BANNERS,
  GetBannerAction,
  GetBannersAction,
  UPDATE_BANNER,
  UPLOAD_BANNER_IMAGE,
  UpdateBannerAction,
  UploadBannerImageAction,
} from "./actionTypes";

import {
  addBanner,
  deleteBanner,
  getBanner,
  getBanners,
  updateBanner,
  uploadBannerImage,
} from "../../helpers/backend_helper";
import {
  addBannerError,
  addBannerSuccess,
  deleteBannerError,
  deleteBannerSuccess,
  getBannerError,
  getBannerSuccess,
  getBannersError,
  getBannersSuccess,
  updateBannerError,
  updateBannerSuccess,
  uploadBannerImageError,
  uploadBannerImageSuccess,
} from "./actions";

function* getBannersSaga({ payload: { request, history } }: GetBannersAction) {
  try {
    const response: ResponseGenerator = yield call(
      getBanners,
      request as PaginateQuery
    );
    yield put(getBannersSuccess(response.data));
  } catch (error) {
    yield put(getBannersError(error));
  }
}

function* getBannerSaga({ payload: { id, history } }: GetBannerAction) {
  try {
    const response: ResponseGenerator = yield call(getBanner, id);
    yield put(getBannerSuccess(response.data));
  } catch (error) {
    yield put(getBannerError(error));
  }
}

function* addBannerSaga({ payload: { request, history } }: AddBannerAction) {
  try {
    yield call(addBanner, request);
    yield put(addBannerSuccess());
  } catch (error) {
    yield put(addBannerError(error));
  }
}

function* updateBannerSaga({
  payload: { id, request, history },
}: UpdateBannerAction) {
  try {
    yield call(updateBanner, id, request);
    yield put(updateBannerSuccess());
  } catch (error) {
    yield put(updateBannerError(error));
  }
}

function* deleteBannerSaga({ payload: { id, history } }: DeleteBannerAction) {
  try {
    yield call(deleteBanner, id);
    yield put(deleteBannerSuccess());
  } catch (error) {
    yield put(deleteBannerError(error));
  }
}

function* uploadBannerImageSaga({
  payload: { file, history, bannerId },
}: UploadBannerImageAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadBannerImage,
      file,
      bannerId
    );
    yield put(uploadBannerImageSuccess(response.data));
  } catch (error) {
    yield put(uploadBannerImageError(error));
  }
}

function* BannerSaga() {
  yield takeEvery(GET_BANNERS, getBannersSaga);
  yield takeEvery(GET_BANNER, getBannerSaga);
  yield takeEvery(ADD_BANNER, addBannerSaga);
  yield takeEvery(UPDATE_BANNER, updateBannerSaga);
  yield takeEvery(DELETE_BANNER, deleteBannerSaga);
  yield takeEvery(UPLOAD_BANNER_IMAGE, uploadBannerImageSaga);
}

export default BannerSaga;
